// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-heading-display-4 {
  font-size: 37px;
}

@media screen and (min-width: 720px) {
  .fs-heading-display-4 {
    font-size: 42px;
  }
}
.image-hero__text-container-wrapper {
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/image-hero.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF;AAEA;EACE,sBAAA;AAAF","sourcesContent":[".fs-heading-display-4 {\n  font-size: 37px;\n}\n\n@media screen and (min-width: 720px) {\n  .fs-heading-display-4 {\n    font-size: 42px;\n  }\n}\n\n.image-hero__text-container-wrapper {\n  word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
